import {environment} from '../../../environments/environment';

const localJSON = './assets/json';
const { ADMIN_TOOL_URL } = environment;
/*
 ****** The index is sorted by alphabetical order for scan it faster,
 ****** please when you add a voice take a minute to add it in the right spot
 ****** keep the order!
 */
export const API = {
  ADMIN_TOOL: {
    userProfile: (username: string) => `${ADMIN_TOOL_URL}/tenants/current/users/${username}/profile`,

    tenants: (username: string, solution: string) => `${ADMIN_TOOL_URL}/users/${username}/solutions/${solution}/tenants`,

    assetSearch: () => `${ADMIN_TOOL_URL}/tenants/current/users/me/search-assets`,

    assetGroupsSearch: () => `${ADMIN_TOOL_URL}/tenants/current/users/me/search-asset-groups`,

    roleFeatures: (role: string) =>
      `${ADMIN_TOOL_URL}/tenants/current/roles/${role}/platforms/CUBE/solutions/${environment.SOLUTION}/features`,

    roleMeasures: (role: string) =>
      `${ADMIN_TOOL_URL}/tenants/current/roles/${role}/platforms/CUBE/solutions/${environment.SOLUTION}/measureCategories`
  },

  USER: {
    me: () => `${environment.REST}/users/me`,

    // DASHBOARD CRUD
    dashboards: (dashboardID?: string) =>
      `${environment.REST}/users/me/dashboards` + (dashboardID ? `/${dashboardID}` : ``),

    filters: () => `${environment.REST}/users/me/filters`
  },
  ZPAGES: {
    // Get a response if the service is currently running.
    healthz: () => `${environment.REST}/healthz`,

    // Get a response with system statistics
    varz: () => `${environment.REST}/varz`
  },

  MARKET_SHARE: {
    marketShare: () => `${environment.REST}/MarketSharesIngestionHttpTrigger`
  },
  INVOICE: {
    invoice: () => `${environment.REST}/InvoicesIngestionHttpTrigger`
  },
  PARTNERS: {
    partners: () => `${environment.REST}/PartnersIngestionHttpTrigger`
  },
  AUDIT_MANAGEMENT: {
    auditManager: () => `${environment.REST}/AuditManagerHttpTrigger`,
    auditCompletion: (userTenant?: string) => userTenant ? `${environment.REST}/AuditCompletionHttpTrigger?userTenant=${userTenant}` : `${environment.REST}/AuditCompletionHttpTrigger`,
    costAllocation: () => `${environment.REST}/CostAllocationHttpTriggered`
  },
  FILE_REPORT: {
    offlineFilesManager: (resource?: string, id?: string, url?: string) => url && resource ? `${environment.REST}/OfflineFilesManagerHttpTrigger/${resource}?url=${url}` :
      id && resource ? `${environment.REST}/OfflineFilesManagerHttpTrigger/${resource}?id=${id}` : `${environment.REST}/OfflineFilesManagerHttpTrigger`
  }
};
